import { FeathersModel } from './feathersModel'
import { User } from './user'

export type ContactType = 'telefon' | 'email' | 'ostatni' | ''

export class Contact extends FeathersModel {
  static serviceName = 'contacts'

  note: string
  userId: string
  user: User
  content: string
  contactType: ContactType
  allowMessaging: boolean
  primary: boolean
  countryCode: string

  turnSubresourcesIntoFrontendModels() {
    if (this.user) this.user = User.createFromProps(User, this.user)
  }

  static getPhoneNumbers(contacts: Contact[]) {
    if (!Array.isArray(contacts)) return ''

    const phoneNumbers = []
    for (const c of contacts) {
      if (c.contactType === 'telefon') {
        phoneNumbers.push(c.content)
      }
    }
    return phoneNumbers.join(', ')
  }

  static getEmails(contacts: Contact[]) {
    if (!Array.isArray(contacts)) return ''

    const emails = []
    for (const c of contacts) {
      if (c.contactType === 'email') {
        emails.push(c.content)
      }
    }
    return emails.join(', ')
  }
}
